import ReuseableCard from "../dashBoard/ReuseableCard";
import { SiElectron } from "react-icons/si";
import { BiBuildings } from "react-icons/bi";
import { CgServer } from "react-icons/cg";
import { GiTreeBranch } from "react-icons/gi";
import EngineeringIcon from "@mui/icons-material/Engineering";

import {
  MdOutlineAdminPanelSettings,
  MdOutlineManageAccounts,
  MdSecurity,
  MdOutlineHealthAndSafety,
} from "react-icons/md";
import Box from "@mui/material/Box";
import { experimentalStyled as styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";

import "./ServiceCard.css";
import { Typography } from "@mui/material";
const ServiceCards = () => {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    alignSelf: "center",
    boxShadow: "none",
  }));
  const LiatArray = [
    { text: "Admin/Hr", IconTag: <MdOutlineAdminPanelSettings /> },
    { text: "One Window Operations", IconTag: <MdOutlineManageAccounts /> },
    { text: "Utility Bills", IconTag: <SiElectron /> },
    { text: "Information Technology ", IconTag: <CgServer /> },
    { text: "Properties", IconTag: <BiBuildings /> },
    { text: "Horticulture ", IconTag: <GiTreeBranch /> },
    { text: "Integrated Security System", IconTag: <MdSecurity /> },
    { text: "Health Safety Enviroment", IconTag: <MdOutlineHealthAndSafety /> },
    { text: "Operation and Maintainance", IconTag: <EngineeringIcon /> },
  ];
  return (
    <>
      <div className="pb-5 bg-light ">
        <Box sx={{ flexGrow: 1 }} className="container">
          <h1 className="pt-3 pb-5 d-flex justify-content-center">Services</h1>
          <Grid
            container
            spacing={{ xs: 2, sm: 2, md: 3 }}
            columns={{ xs: 3, sm: 8, md: 12, lg: 12 }}
          >
            {Array.from(LiatArray).map((_, index) => (
              <Grid item xs={3} sm={4} md={4} lg={4} key={index}>
                <Item className=" center">
                  <ReuseableCard
                    text={LiatArray[index].text}
                    IconName={LiatArray[index].IconTag}
                  />
                </Item>
              </Grid>
            ))}
          </Grid>
        </Box>
      </div>
    </>
  );
};

export default ServiceCards;
